import {HttpInterceptorFn} from '@angular/common/http';
import {AuthService} from '../services/auth.service';
import {inject} from '@angular/core';
import {I18nService} from '@shared/services/i18n.service';
import {ENDPOINT_DOMAIN, ENDPOINT_DOMAIN_API} from '@shared/consts/auth';

export const httpApiInterceptor: HttpInterceptorFn = (req, next) => {
  const endpoint = inject(ENDPOINT_DOMAIN);

  if (endpoint && req.url && req.url.startsWith(endpoint)) {
    if (req.url.startsWith(endpoint + '/storage/')) {
      return next(req);
    }

    let headers = req.headers.set('X-Requested-With', 'XMLHttpRequest').set('ngsw-bypass', '*');

    const authToken = inject(AuthService).authToken();

    if (authToken) {
      headers = headers.set('Authorization', `Bearer ${authToken}`);
    }

    const defaultLang = inject(I18nService).getDefaultLang();
    if (defaultLang) {
      headers = headers.set('X-Lang', defaultLang);
    }

    const newRequest = req.clone({
      headers,
      withCredentials: !req.url.startsWith(inject(ENDPOINT_DOMAIN_API)),
      // withCredentials: req.withCredentials,
    });

    return next(newRequest);
  }

  return next(req);
};
